const stylesheet = `

.react-jinke-music-player-main svg:active, .react-jinke-music-player-main svg:hover {
    color: #9a7420
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle, .react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-track {
    background-color: #b8862e;
    border-color: #9a7420
}

.react-jinke-music-player-main ::-webkit-scrollbar-thumb {
    background-color: #c9b896;
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle:active {
    box-shadow: 0 0 2px #b8862e
}

.react-jinke-music-player-main .audio-item.playing svg {
    color: #9a7420
}

.react-jinke-music-player-main .audio-item.playing .player-singer {
    color: #9a7420 !important
}

.react-jinke-music-player-main .rc-slider-rail {
    background-color: #ddd7cc !important
}

.react-jinke-music-player-main .lyric-btn {
    color: #1a1917 !important
}

.react-jinke-music-player-main .music-player-panel {
    color: #1a1917 !important
}

.react-jinke-music-player-main .lyric-btn-active svg {
    color: #9a7420 !important
}

.music-player-lyric {
    color: #9a7420 !important
}

.audio-lists-panel-content .audio-item.playing, .audio-lists-panel-content .audio-item.playing svg {
    color: #9a7420
}
.audio-lists-panel-content .audio-item:active .group:not(.player-delete) svg, .audio-lists-panel-content .audio-item:hover .group:not(.player-delete) svg {
    color: #9a7420
}

.progress-bar-content .audio-title a {
    color: #1a1917
}

.MuiCheckbox-colorSecondary.Mui-checked {
    color: #b8862e !important
}
`
export default stylesheet
